import { render } from "./PaymentMethodIndex.vue?vue&type=template&id=3b4564cb"
import script from "./PaymentMethodIndex.vue?vue&type=script&lang=js"
export * from "./PaymentMethodIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__